export const reorder = (columns, startIndex, endIndex) => {
    const result = Array.from(Object.keys(columns));
    const [removed] = result.splice(startIndex, 1, result[endIndex]);
    result.splice(endIndex, 1, removed);
  
    return result;
};

export const reorderList = (columns, startIndex, endIndex) => {
    let updatedList = {};

    const result = reorder(columns, startIndex, endIndex);

    for(const [i, item] of result.entries()) {
        if(i === endIndex) {
            updatedList = {...updatedList, [item]: {...columns[item], enabled: false}};
        } else if(i === startIndex) {
            updatedList = {...updatedList, [item]: {...columns[item], enabled: true}};
        } else {
            updatedList = {...updatedList, [item]: {...columns[item]}};
        }
    }

    return updatedList;
}

export const compareObjectsByOrder = (obj1, obj2) => {
    const obj1Keys = Object.keys(obj1);
    const obj2Keys = Object.keys(obj2);
  
    if (obj1Keys.length !== obj2Keys.length) {
      return false;
    }
  
    const keySet = new Set(obj2Keys);
  
    for (let i = 0; i < obj1Keys.length; i++) {
      const key = obj1Keys[i];
  
      if (!keySet.has(key) || obj1[key] !== obj2[key] || obj2Keys[i] !== key) {
        return false;
      }
    }
  
    return true;
  }